import { CreateAccountState } from './CreateAccountReducer';

const emailRegex = /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/;

const passwordRegex = /^(?=[a-zA-Z\d@#$%]*\d)(?=[a-zA-Z\d@#$%]*[a-z])(?=[a-zA-Z\d@#$%]*[@#$%])(?=[a-zA-Z\d@#$%]*[A-Z])(?=[a-zA-Z\d@#$%]*[a-zA-Z])[a-zA-Z\d@#$%]{8,20}$/;
const nameRegex = /.+/;

function validate(form: CreateAccountState) {
  const { email, first, last, password, confirm, security } = form;
  const errors = [];
  if (!emailRegex.test(email)) errors.push('email');
  if (!nameRegex.test(first)) errors.push('first');
  if (!nameRegex.test(last)) errors.push('last');
  if (!passwordRegex.test(password)) errors.push('password');
  if (password !== confirm) errors.push('confirm');
  if (!security[1].question) errors.push('s1q');
  if (!security[1].answer) errors.push('s1a');
  if (!security[2].question) errors.push('s2q');
  if (!security[2].answer) errors.push('s2a');
  if (!security[3].question) errors.push('s3q');
  if (!security[3].answer) errors.push('s3a');
  return errors;
}

export default validate;
